import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';
import { EBrandCategory } from './enums.js';
import { colorErrorMessage } from '../_common/validation.js';

const SchemaExclusive = T.Array(T.String(), {
  maxItems: 0,
  error: 'Marca exclusiva não pode ter marcas vinculadas',
});

const SchemaMultibrand = T.Array(T.String({ format: 'uuid' }), {
  minItems: 2,
  error: 'Mínimo de duas marcas vinculadas',
});

export const EditBrandSchema = T.Object({
  uuid: T.String({ format: 'uuid', error: 'Uuid da marca é um campo obrigatório' }),
  name: T.String({ minLength: 1, error: 'Nome da marca é um campo obrigatório' }),
  code: T.String({ maxLength: 3, minLength: 3, error: 'Identificador de 3 dígitos é um campo obrigatório' }),
  ledColor: T.Intersect([
    T.String({ minLength: 1, error: 'Campo obrigatório' }),
    T.String({ format: 'ledColor', error: colorErrorMessage }),
  ]),
  fileType: T.Optional(T.String({ error: 'Imagem é obrigatória' })),
  /** Pre-uploaded image key from image.uploadCompressed endpoint */
  imageKey: T.Optional(T.String()),
  active: T.Boolean({ error: 'Status é obrigatório' }),
  category: T.Enum(EBrandCategory, { error: 'Categoria é um campo obrigatório' }),
  relatedBrands: T.Union([SchemaExclusive, SchemaMultibrand]),
});

export type EditBrandInputType = typeof EditBrandSchema.static;

export async function ValidateEditBrandInput(value: unknown): Promise<EditBrandInputType> {
  return Value.Parse(EditBrandSchema, value);
}

export function checkBrandEditInput(
  field: string,
  value: unknown,
  context: Partial<EditBrandInputType> = {}
): string | boolean {
  if (
    field === 'relatedBrands' &&
    context.category === EBrandCategory.EXCLUSIVE &&
    Array.isArray(value) &&
    value.length > 0
  ) {
    return 'Marca exclusiva não pode ter marcas vinculadas';
  }

  if (
    field === 'relatedBrands' &&
    context.category === EBrandCategory.MULTIBRAND &&
    Array.isArray(value) &&
    value.length < 2
  ) {
    return 'Mínimo de duas marcas vinculadas';
  }
  return validateField(EditBrandSchema, field, value);
}
